import React, { useCallback, useEffect, useRef, useState } from "react";
import { 
  Route, 
  Routes 
} from "react-router-dom";

import { CORE_DATA_TYPES, DATA_TYPE_INFO } from "@dndModels/Constants";

import UserIndex from "@views/user";
import UserEdit from "@views/user/edit";

// import DandDMainPage from "../systems/d&d/views/MainPage";
// import PathfinderMainPage from "../systems/pathfinder/views/MainPage";
// import MyTTRPGMainPage from "../systems/myttrpg/views/MainPage";

import Attributions from "@views/attributions";
import OGL from "@views/ogl";

import Login from "@components/Login";
import DandDAPI from "@dndUtilities/system_api";
// import UserAPI from "../utilities/user_api";

import LoadingBox from "@components/input/LoadingBox";

import AdminOnly from "@dndViews/AdminOnly";

import HomePage from "@views/Home";

import DeityIndex from "@dndViews/deity";
import DeityEdit from "@dndViews/deity/edit";

import UserTicketIndex from "@dndViews/user_ticket";
import UserTicketEdit from "@dndViews/user_ticket/edit";

import TicketIndex from "@dndViews/ticket";
import TicketEdit from "@dndViews/ticket/edit";

import SpellIndex from "@dndViews/spell";
import SpellEdit from "@dndViews/spell/edit";
import SpellParseAdd from "@dndViews/spell/parseAdd";

import SpellSlotTableIndex from "@dndViews/spell_slot_tables";
import SpellSlotTableEdit from "@dndViews/spell_slot_tables/edit";

import GameCardIndex from "@dndViews/game_card";
import GameCardEdit from "@dndViews/game_card/edit";

import GameDeckIndex from "@dndViews/game_deck";
import GameDeckEdit from "@dndViews/game_deck/edit";

import TableIndex from "@dndViews/table";
import TableEdit from "@dndViews/table/edit";

import ArmorTypeIndex from "@dndViews/armor_type";
import ArmorTypeEdit from "@dndViews/armor_type/edit";

import BackgroundIndex from "@dndViews/background";
import BackgroundEdit from "@dndViews/background/edit";

import ResourceIndex from "@dndViews/resource";
import ResourceEdit from "@dndViews/resource/edit";

import RollableTableIndex from "@dndViews/rollable_table";
import RollableTableEdit from "@dndViews/rollable_table/edit";

import LootTableIndex from "@dndViews/loot_table";
import LootTableEdit from "@dndViews/loot_table/edit";

import CampaignIndex from "@dndViews/campaign";
import CampaignEdit from "@dndViews/campaign/edit";
import CampaignDetails from "@dndViews/campaign/details";
import CampaignJoin from "@dndViews/campaign/join";
import CampaignDecks from "@dndViews/campaign/decks";

import CharacterIndex from "@dndViews/character";
import CharacterDetails from "@dndViews/character/details";
import CharacterShared from "@dndViews/character/shared";
import AllCharacters from "@dndViews/character/all";
import CharacterPrintable from "@dndViews/character/printable";

import EncounterIndex from "@dndViews/encounter";
import EncounterDetails from "@dndViews/encounter/details";

import CreatureIndex from "@dndViews/creature";
import CreatureEdit from "@dndViews/creature/edit";
import CreatureMergeAdd from "@dndViews/creature/mergeAdd";
import CreatureParseAdd from "@dndViews/creature/parseAdd";

import CreatureGroupIndex from "@dndViews/creature_group";
import CreatureGroupEdit from "@dndViews/creature_group/edit";

import CreatureGiftIndex from "@dndViews/creature_gift";
import CreatureGiftEdit from "@dndViews/creature_gift/edit";

import FeatIndex from "@dndViews/feat";
import FeatEdit from "@dndViews/feat/edit";

import EldritchInvocationIndex from "@dndViews/eldritch_invocation";
import EldritchInvocationEdit from "@dndViews/eldritch_invocation/edit";

import FightingStyleIndex from "@dndViews/fighting_style";
import FightingStyleEdit from "@dndViews/fighting_style/edit";

import ConditionIndex from "@dndViews/condition";
import ConditionEdit from "@dndViews/condition/edit";

import PactBoonIndex from "@dndViews/pact_boon";
import PactBoonEdit from "@dndViews/pact_boon/edit";

import GameClassIndex from "@dndViews/game_class";
import GameClassEdit from "@dndViews/game_class/edit";

import SubclassIndex from "@dndViews/subclass";
import SubclassEdit from "@dndViews/subclass/edit";

import EquipmentPackIndex from "@dndViews/equipment_pack";
import EquipmentPackEdit from "@dndViews/equipment_pack/edit";

import ItemIndex from "@dndViews/item";
import ItemEdit from "@dndViews/item/edit";
import ItemParseAdd from "@dndViews/item/parseAdd";

import MagicItemKeywordIndex from "@dndViews/magic_item_keyword";
import MagicItemKeywordEdit from "@dndViews/magic_item_keyword/edit";

import WeaponMasteryPropertyIndex from "@dndViews/weapon_mastery_property";
import WeaponMasteryPropertyEdit from "@dndViews/weapon_mastery_property/edit";

import RaceIndex from "@dndViews/race";
import RaceEdit from "@dndViews/race/edit";

import SubraceIndex from "@dndViews/subrace";
import SubraceEdit from "@dndViews/subrace/edit";

import SkillIndex from "@dndViews/skill";
import SkillEdit from "@dndViews/skill/edit";

import SenseIndex from "@dndViews/sense";
import SenseEdit from "@dndViews/sense/edit";

import LanguageIndex from "@dndViews/language";
import LanguageEdit from "@dndViews/language/edit";

import ReusableStringIndex from "@dndViews/reusable_string";
import ReusableStringEdit from "@dndViews/reusable_string/edit";

import GiftIndex from "@dndViews/gift";
import GiftEdit from "@dndViews/gift/edit";
import GiftParseAdd from "@dndViews/gift/parseAdd";

import BastionFacilityIndex from "@dndViews/bastion_facility";
import BastionFacilityEdit from "@dndViews/bastion_facility/edit";

import TransformIndex from "@dndViews/transform";
import TransformEdit from "@dndViews/transform/edit";

// import AdaptationIndex from "../systems/d&d/views/adaptation";
// import AdaptationEdit from "../systems/d&d/views/adaptation/edit";

import SpellListIndex from "@dndViews/spell_list";
import SpellListEdit from "@dndViews/spell_list/edit";

import TemplateBaseIndex from "@dndViews/template_base";
import TemplateBaseEdit from "@dndViews/template_base/edit";

import FloatingFeatureIndex from "@dndViews/floating_feature";
import FloatingFeatureEdit from "@dndViews/floating_feature/edit";

import SpecialFeatureIndex from "@dndViews/special_feature";
import SpecialFeatureEdit from "@dndViews/special_feature/edit";

import SourceBookIndex from "@dndViews/source_book";
import SourceBookEdit from "@dndViews/source_book/edit";

import ToolIndex from "@dndViews/tool";
import ToolEdit from "@dndViews/tool/edit";

import StandardFeaturesIndex from "@dndViews/standard_features";
import StandardFeaturesEdit from "@dndViews/standard_features/edit";
import { DataType } from "@dndModels/Types";

interface Props { 
  loginOpen: boolean;
  toggleLogin: () => void;
}

const data_type_map: { [data_type: string]: string } = {}; 
CORE_DATA_TYPES.forEach(o => {
  const dt_info = DATA_TYPE_INFO.find(o2 => o2.data_type === o);
  if (dt_info) {
    data_type_map[o] = dt_info.plural;
  }
}); 

// const user_api = UserAPI.getInstance();
const dandd_api = DandDAPI.getInstance();

export default function DandDMainPage({ 
  loginOpen, 
  toggleLogin
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading_message, setLoadingMessage] = useState("Loading");
  const [percentage, setPercentage] = useState(0);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const load = useCallback(() => {
    setFetched(true);
    // if (!window.location.href.includes("admin_only")) {
    setLoading(true);
    
    const onComplete = () => {
      setLoading(false);
      dandd_api.subscription_holder.postReload();
    };
    const onProgress = (data_type: string, percent: number ) => {
      setPercentage(percent * 100);
      setLoadingMessage(`Loading ${data_type_map[data_type]}`);
    };
    const onError = (message: string) => {
      setLoadingMessage(message);
    };
    dandd_api.getSetOfObjectsWithCallbacks({ data_types: Object.keys(data_type_map) as DataType[], 
      onComplete, onProgress, onError 
    });
    // }
  }, []);

  const reload = useCallback(() => {
    console.log("reload");
    dandd_api.smart_hash = {};
    dandd_api.temp_hash = {};
    clearInterval(dandd_api.temp_hash_interval);
    dandd_api.temp_hash_interval = null;
    load();
  }, [load]);

  useEffect(() => {
    if (!fetched) {
      load();
      dandd_api.subscription_holder.subscribe("Reload", mounted, reload);
    }
  });

  if (!fetched || loading) {
    return (<LoadingBox message={loading_message} percentage={percentage} size={window.innerHeight * 0.5} height={window.innerHeight - 64} width={window.innerWidth - 24} />); // width={window.innerWidth - 17}
  } else if (loginOpen) {
    return (
      <Login toggleLogin={toggleLogin} />
    );
  } else {
    return (
      <Routes>
        <Route path="/" element={<HomePage/>} />
        <Route path="/home" element={<HomePage/>} />
        <Route path="/attributions" element={<Attributions/>} />
        <Route path="/ogl" element={<OGL/>} />
                
        <Route path="/labs/user" element={<UserIndex/>} />
        <Route path="/labs/user/edit/:id" element={<UserEdit/>} />
        <Route path="/user/user" element={<UserIndex/>} />
        <Route path="/user/user/edit/:id" element={<UserEdit/>} />
        <Route path="/dandd/user" element={<UserIndex/>} />
        <Route path="/dandd/user/edit/:id" element={<UserEdit/>} />

        <Route path="/dandd/admin_only" element={<AdminOnly/>} />
        <Route path="/labs/admin_only" element={<AdminOnly/>} />

        <Route path="/dandd" element={<HomePage/>} />
        <Route path="/dandd/home" element={<HomePage/>} />
        <Route path="/labs" element={<HomePage/>} />
        <Route path="/labs/home" element={<HomePage/>} />

        <Route path="/dandd/skill" element={<SkillIndex/>} />
        <Route path="/dandd/skill/create" element={<SkillEdit/>} />
        <Route path="/dandd/skill/edit/:id" element={<SkillEdit/>} />
        <Route path="/labs/skill" element={<SkillIndex/>} />
        <Route path="/labs/skill/create" element={<SkillEdit/>} />
        <Route path="/labs/skill/edit/:id" element={<SkillEdit/>} />

        <Route path="/dandd/sense" element={<SenseIndex/>} />
        <Route path="/dandd/sense/create" element={<SenseEdit/>} />
        <Route path="/dandd/sense/edit/:id" element={<SenseEdit/>} />
        <Route path="/labs/sense" element={<SenseIndex/>} />
        <Route path="/labs/sense/create" element={<SenseEdit/>} />
        <Route path="/labs/sense/edit/:id" element={<SenseEdit/>} />

        <Route path="/dandd/deity" element={<DeityIndex/>} />
        <Route path="/dandd/deity/create" element={<DeityEdit/>} />
        <Route path="/dandd/deity/edit/:id" element={<DeityEdit/>} />
        <Route path="/labs/deity" element={<DeityIndex/>} />
        <Route path="/labs/deity/create" element={<DeityEdit/>} />
        <Route path="/labs/deity/edit/:id" element={<DeityEdit/>} />

        <Route path="/dandd/user_ticket" element={<UserTicketIndex/>} />
        <Route path="/dandd/user_ticket/create" element={<UserTicketEdit/>} />
        <Route path="/dandd/user_ticket/edit/:id" element={<UserTicketEdit/>} />
        <Route path="/labs/user_ticket" element={<UserTicketIndex/>} />
        <Route path="/labs/user_ticket/create" element={<UserTicketEdit/>} />
        <Route path="/labs/user_ticket/edit/:id" element={<UserTicketEdit/>} />

        <Route path="/dandd/ticket" element={<TicketIndex/>} />
        <Route path="/dandd/ticket/create" element={<TicketEdit/>} />
        <Route path="/dandd/ticket/edit/:id" element={<TicketEdit/>} />
        <Route path="/labs/ticket" element={<TicketIndex/>} />
        <Route path="/labs/ticket/create" element={<TicketEdit/>} />
        <Route path="/labs/ticket/edit/:id" element={<TicketEdit/>} />

        <Route path="/dandd/spell" element={<SpellIndex/>} />
        <Route path="/dandd/spell/create" element={<SpellEdit/>} />
        <Route path="/dandd/spell/edit/:id" element={<SpellEdit/>} />
        <Route path="/dandd/spell/parse_add" element={<SpellParseAdd/>} />
        <Route path="/labs/spell" element={<SpellIndex/>} />
        <Route path="/labs/spell/create" element={<SpellEdit/>} />
        <Route path="/labs/spell/edit/:id" element={<SpellEdit/>} />
        <Route path="/labs/spell/parse_add" element={<SpellParseAdd/>} />

        <Route path="/dandd/spell_slot_type" element={<SpellSlotTableIndex/>} />
        <Route path="/dandd/spell_slot_type/create" element={<SpellSlotTableEdit/>} />
        <Route path="/dandd/spell_slot_type/edit/:id" element={<SpellSlotTableEdit/>} />
        <Route path="/labs/spell_slot_type" element={<SpellSlotTableIndex/>} />
        <Route path="/labs/spell_slot_type/create" element={<SpellSlotTableEdit/>} />
        <Route path="/labs/spell_slot_type/edit/:id" element={<SpellSlotTableEdit/>} />

        <Route path="/dandd/game_card" element={<GameCardIndex/>} />
        <Route path="/dandd/game_card/create" element={<GameCardEdit/>} />
        <Route path="/dandd/game_card/edit/:id" element={<GameCardEdit/>} />
        <Route path="/labs/game_card" element={<GameCardIndex/>} />
        <Route path="/labs/game_card/create" element={<GameCardEdit/>} />
        <Route path="/labs/game_card/edit/:id" element={<GameCardEdit/>} />

        <Route path="/dandd/game_deck" element={<GameDeckIndex/>} />
        <Route path="/dandd/game_deck/create" element={<GameDeckEdit/>} />
        <Route path="/dandd/game_deck/edit/:id" element={<GameDeckEdit/>} />
        <Route path="/labs/game_deck" element={<GameDeckIndex/>} />
        <Route path="/labs/game_deck/create" element={<GameDeckEdit/>} />
        <Route path="/labs/game_deck/edit/:id" element={<GameDeckEdit/>} />

        <Route path="/dandd/table" element={<TableIndex/>} />
        <Route path="/dandd/table/create" element={<TableEdit/>} />
        <Route path="/dandd/table/edit/:id" element={<TableEdit/>} />
        <Route path="/labs/table" element={<TableIndex/>} />
        <Route path="/labs/table/create" element={<TableEdit/>} />
        <Route path="/labs/table/edit/:id" element={<TableEdit/>} />

        <Route path="/dandd/armor_type" element={<ArmorTypeIndex/>} />
        <Route path="/dandd/armor_type/create" element={<ArmorTypeEdit/>} />
        <Route path="/dandd/armor_type/edit/:id" element={<ArmorTypeEdit/>} />
        <Route path="/labs/armor_type" element={<ArmorTypeIndex/>} />
        <Route path="/labs/armor_type/create" element={<ArmorTypeEdit/>} />
        <Route path="/labs/armor_type/edit/:id" element={<ArmorTypeEdit/>} />

        <Route path="/dandd/language" element={<LanguageIndex/>} />
        <Route path="/dandd/language/create" element={<LanguageEdit/>} />
        <Route path="/dandd/language/edit/:id" element={<LanguageEdit/>} />
        <Route path="/labs/language" element={<LanguageIndex/>} />
        <Route path="/labs/language/create" element={<LanguageEdit/>} />
        <Route path="/labs/language/edit/:id" element={<LanguageEdit/>} />

        <Route path="/dandd/reusable_string" element={<ReusableStringIndex/>} />
        <Route path="/dandd/reusable_string/create" element={<ReusableStringEdit/>} />
        <Route path="/dandd/reusable_string/edit/:id" element={<ReusableStringEdit/>} />
        <Route path="/labs/reusable_string" element={<ReusableStringIndex/>} />
        <Route path="/labs/reusable_string/create" element={<ReusableStringEdit/>} />
        <Route path="/labs/reusable_string/edit/:id" element={<ReusableStringEdit/>} />

        <Route path="/dandd/gift" element={<GiftIndex/>} />
        <Route path="/dandd/gift/create" element={<GiftEdit/>} />
        <Route path="/dandd/gift/edit/:id" element={<GiftEdit/>} />
        <Route path="/dandd/gift/parse_add" element={<GiftParseAdd/>} />
        <Route path="/labs/gift" element={<GiftIndex/>} />
        <Route path="/labs/gift/create" element={<GiftEdit/>} />
        <Route path="/labs/gift/edit/:id" element={<GiftEdit/>} />

        <Route path="/dandd/bastion_facility" element={<BastionFacilityIndex/>} />
        <Route path="/dandd/bastion_facility/create" element={<BastionFacilityEdit/>} />
        <Route path="/dandd/bastion_facility/edit/:id" element={<BastionFacilityEdit/>} />
        <Route path="/labs/bastion_facility" element={<BastionFacilityIndex/>} />
        <Route path="/labs/bastion_facility/create" element={<BastionFacilityEdit/>} />
        <Route path="/labs/bastion_facility/edit/:id" element={<BastionFacilityEdit/>} />
        
        <Route path="/dandd/transform" element={<TransformIndex/>} />
        <Route path="/dandd/transform/create" element={<TransformEdit/>} />
        <Route path="/dandd/transform/edit/:id" element={<TransformEdit/>} />
        <Route path="/labs/transform" element={<TransformIndex/>} />
        <Route path="/labs/transform/create" element={<TransformEdit/>} />
        <Route path="/labs/transform/edit/:id" element={<TransformEdit/>} />
{/*         
        <Route path="/dandd/adaptation" element={<AdaptationIndex/>} />
        <Route path="/dandd/adaptation/create" element={<AdaptationEdit/>} />
        <Route path="/dandd/adaptation/edit/:id" element={<AdaptationEdit/>} />
        <Route path="/labs/adaptation" element={<AdaptationIndex/>} />
        <Route path="/labs/adaptation/create" element={<AdaptationEdit/>} />
        <Route path="/labs/adaptation/edit/:id" element={<AdaptationEdit/>} /> */}

        <Route path="/dandd/background" element={<BackgroundIndex/>} />
        <Route path="/dandd/background/create" element={<BackgroundEdit/>} />
        <Route path="/dandd/background/edit/:id" element={<BackgroundEdit/>} />
        <Route path="/labs/background" element={<BackgroundIndex/>} />
        <Route path="/labs/background/create" element={<BackgroundEdit/>} />
        <Route path="/labs/background/edit/:id" element={<BackgroundEdit/>} />
        
        <Route path="/dandd/resource" element={<ResourceIndex/>} />
        <Route path="/dandd/resource/create" element={<ResourceEdit/>} />
        <Route path="/dandd/resource/edit/:id" element={<ResourceEdit/>} />
        <Route path="/labs/resource" element={<ResourceIndex/>} />
        <Route path="/labs/resource/create" element={<ResourceEdit/>} />
        <Route path="/labs/resource/edit/:id" element={<ResourceEdit/>} />

        <Route path="/dandd/item" element={<ItemIndex/>} />
        <Route path="/dandd/item/create" element={<ItemEdit/>} />
        <Route path="/dandd/item/edit/:id" element={<ItemEdit/>} />
        <Route path="/dandd/item/parse_add" element={<ItemParseAdd/>} />
        <Route path="/labs/item" element={<ItemIndex/>} />
        <Route path="/labs/item/create" element={<ItemEdit/>} />
        <Route path="/labs/item/edit/:id" element={<ItemEdit/>} />

        <Route path="/dandd/rollable_table" element={<RollableTableIndex/>} />
        <Route path="/dandd/rollable_table/create" element={<RollableTableEdit/>} />
        <Route path="/dandd/rollable_table/edit/:id" element={<RollableTableEdit/>} />
        <Route path="/labs/rollable_table" element={<RollableTableIndex/>} />
        <Route path="/labs/rollable_table/create" element={<RollableTableEdit/>} />
        <Route path="/labs/rollable_table/edit/:id" element={<RollableTableEdit/>} />

        <Route path="/dandd/loot_table" element={<LootTableIndex/>} />
        <Route path="/dandd/loot_table/create" element={<LootTableEdit/>} />
        <Route path="/dandd/loot_table/edit/:id" element={<LootTableEdit/>} />
        <Route path="/labs/loot_table" element={<LootTableIndex/>} />
        <Route path="/labs/loot_table/create" element={<LootTableEdit/>} />
        <Route path="/labs/loot_table/edit/:id" element={<LootTableEdit/>} />

        <Route path="/dandd/campaign" element={<CampaignIndex/>} />
        <Route path="/dandd/campaign/details/:id" element={<CampaignDetails/>} />
        <Route path="/dandd/campaign/decks/:id" element={<CampaignDecks/>} />
        <Route path="/dandd/campaign/join/:id/:invite" element={<CampaignJoin/>} />
        <Route path="/dandd/campaign/create" element={<CampaignEdit/>} />
        <Route path="/dandd/campaign/edit/:id" element={<CampaignEdit/>} />
        <Route path="/labs/campaign" element={<CampaignIndex/>} />
        <Route path="/labs/campaign/details/:id" element={<CampaignDetails/>} />
        <Route path="/labs/campaign/join/:id/:invite" element={<CampaignJoin/>} />
        <Route path="/labs/campaign/create" element={<CampaignEdit/>} />
        <Route path="/labs/campaign/edit/:id" element={<CampaignEdit/>} />

        <Route path="/dandd/character" element={<CharacterIndex/>} />
        <Route path="/dandd/character/details/:id" element={<CharacterDetails/>} />
        <Route path="/dandd/character/create_on_campaign/:campaign_id/:unassigned" element={<CharacterDetails/>} />
        <Route path="/dandd/character/shared/:id" element={<CharacterShared/>} />
        <Route path="/dandd/character/printable/:id" element={<CharacterPrintable/>} />
        <Route path="/labs/character" element={<CharacterIndex/>} />
        <Route path="/labs/character/details/:id" element={<CharacterDetails/>} />
        <Route path="/labs/character/create_on_campaign/:campaign_id/:unassigned" element={<CharacterDetails/>} />
        <Route path="/labs/character/shared/:id" element={<CharacterShared/>} />
        <Route path="/labs/character/printable/:id" element={<CharacterPrintable/>} />
        
        <Route path="/dandd/all_characters" element={<AllCharacters/>} />
        <Route path="/labs/all_characters" element={<AllCharacters/>} />

        <Route path="/dandd/encounter" element={<EncounterIndex/>} />
        <Route path="/dandd/encounter/details/:id" element={<EncounterDetails/>} />
        <Route path="/dandd/encounter/create_on_campaign/:campaign_id/:unassigned" element={<EncounterDetails/>} />
        <Route path="/labs/encounter" element={<EncounterIndex/>} />
        <Route path="/labs/encounter/details/:id" element={<EncounterDetails/>} />
        <Route path="/labs/encounter/create_on_campaign/:campaign_id/:unassigned" element={<EncounterDetails/>} />

        <Route path="/dandd/creature" element={<CreatureIndex/>} />
        <Route path="/dandd/creature/create" element={<CreatureEdit/>} />
        <Route path="/dandd/creature/edit/:id" element={<CreatureEdit/>} />
        <Route path="/dandd/creature/from_character/:char_id" element={<CreatureEdit/>} />
        <Route path="/dandd/creature/merge_add" element={<CreatureMergeAdd/>} />
        <Route path="/dandd/creature/parse_add" element={<CreatureParseAdd/>} />
        <Route path="/labs/creature" element={<CreatureIndex/>} />
        <Route path="/labs/creature/create" element={<CreatureEdit/>} />
        <Route path="/labs/creature/edit/:id" element={<CreatureEdit/>} />
        <Route path="/labs/creature/from_character/:char_id" element={<CreatureEdit/>} />
        <Route path="/labs/creature/merge_add" element={<CreatureMergeAdd/>} />
        <Route path="/labs/creature/parse_add" element={<CreatureParseAdd/>} />
        
        <Route path="/dandd/creature_group" element={<CreatureGroupIndex/>} />
        <Route path="/dandd/creature_group/create" element={<CreatureGroupEdit/>} />
        <Route path="/dandd/creature_group/edit/:id" element={<CreatureGroupEdit/>} />
        <Route path="/labs/creature_group" element={<CreatureGroupIndex/>} />
        <Route path="/labs/creature_group/create" element={<CreatureGroupEdit/>} />
        <Route path="/labs/creature_group/edit/:id" element={<CreatureGroupEdit/>} />
        
        <Route path="/dandd/creature_gift" element={<CreatureGiftIndex/>} />
        <Route path="/dandd/creature_gift/create" element={<CreatureGiftEdit/>} />
        <Route path="/dandd/creature_gift/edit/:id" element={<CreatureGiftEdit/>} />
        <Route path="/labs/creature_gift" element={<CreatureGiftIndex/>} />
        <Route path="/labs/creature_gift/create" element={<CreatureGiftEdit/>} />
        <Route path="/labs/creature_gift/edit/:id" element={<CreatureGiftEdit/>} />

        <Route path="/dandd/feat" element={<FeatIndex/>} />
        <Route path="/dandd/feat/create" element={<FeatEdit/>} />
        <Route path="/dandd/feat/edit/:id" element={<FeatEdit/>} />
        <Route path="/labs/feat" element={<FeatIndex/>} />
        <Route path="/labs/feat/create" element={<FeatEdit/>} />
        <Route path="/labs/feat/edit/:id" element={<FeatEdit/>} />

        <Route path="/dandd/eldritch_invocation" element={<EldritchInvocationIndex/>} />
        <Route path="/dandd/eldritch_invocation/create" element={<EldritchInvocationEdit/>} />
        <Route path="/dandd/eldritch_invocation/edit/:id" element={<EldritchInvocationEdit/>} />
        <Route path="/labs/eldritch_invocation" element={<EldritchInvocationIndex/>} />
        <Route path="/labs/eldritch_invocation/create" element={<EldritchInvocationEdit/>} />
        <Route path="/labs/eldritch_invocation/edit/:id" element={<EldritchInvocationEdit/>} />

        <Route path="/dandd/fighting_style" element={<FightingStyleIndex/>} />
        <Route path="/dandd/fighting_style/create" element={<FightingStyleEdit/>} />
        <Route path="/dandd/fighting_style/edit/:id" element={<FightingStyleEdit/>} />
        <Route path="/labs/fighting_style" element={<FightingStyleIndex/>} />
        <Route path="/labs/fighting_style/create" element={<FightingStyleEdit/>} />
        <Route path="/labs/fighting_style/edit/:id" element={<FightingStyleEdit/>} />

        <Route path="/dandd/condition" element={<ConditionIndex/>} />
        <Route path="/dandd/condition/create" element={<ConditionEdit/>} />
        <Route path="/dandd/condition/edit/:id" element={<ConditionEdit/>} />
        <Route path="/labs/condition" element={<ConditionIndex/>} />
        <Route path="/labs/condition/create" element={<ConditionEdit/>} />
        <Route path="/labs/condition/edit/:id" element={<ConditionEdit/>} />

        <Route path="/dandd/pact_boon" element={<PactBoonIndex/>} />
        <Route path="/dandd/pact_boon/create" element={<PactBoonEdit/>} />
        <Route path="/dandd/pact_boon/edit/:id" element={<PactBoonEdit/>} />
        <Route path="/labs/pact_boon" element={<PactBoonIndex/>} />
        <Route path="/labs/pact_boon/create" element={<PactBoonEdit/>} />
        <Route path="/labs/pact_boon/edit/:id" element={<PactBoonEdit/>} />

        <Route path="/dandd/game_class" element={<GameClassIndex/>} />
        <Route path="/dandd/game_class/create" element={<GameClassEdit/>} />
        <Route path="/dandd/game_class/edit/:id" element={<GameClassEdit/>} />
        <Route path="/labs/game_class" element={<GameClassIndex/>} />
        <Route path="/labs/game_class/create" element={<GameClassEdit/>} />
        <Route path="/labs/game_class/edit/:id" element={<GameClassEdit/>} />

        <Route path="/dandd/subclass" element={<SubclassIndex/>} />
        <Route path="/dandd/subclass/create" element={<SubclassEdit/>} />
        <Route path="/dandd/subclass/edit/:id" element={<SubclassEdit/>} />
        <Route path="/labs/subclass" element={<SubclassIndex/>} />
        <Route path="/labs/subclass/create" element={<SubclassEdit/>} />
        <Route path="/labs/subclass/edit/:id" element={<SubclassEdit/>} />

        <Route path="/dandd/equipment_pack" element={<EquipmentPackIndex/>} />
        <Route path="/dandd/equipment_pack/create" element={<EquipmentPackEdit/>} />
        <Route path="/dandd/equipment_pack/edit/:id" element={<EquipmentPackEdit/>} />
        <Route path="/labs/equipment_pack" element={<EquipmentPackIndex/>} />
        <Route path="/labs/equipment_pack/create" element={<EquipmentPackEdit/>} />
        <Route path="/labs/equipment_pack/edit/:id" element={<EquipmentPackEdit/>} />

        <Route path="/dandd/magic_item_keyword" element={<MagicItemKeywordIndex/>} />
        <Route path="/dandd/magic_item_keyword/create" element={<MagicItemKeywordEdit/>} />
        <Route path="/dandd/magic_item_keyword/edit/:id" element={<MagicItemKeywordEdit/>} />
        <Route path="/labs/magic_item_keyword" element={<MagicItemKeywordIndex/>} />
        <Route path="/labs/magic_item_keyword/create" element={<MagicItemKeywordEdit/>} />
        <Route path="/labs/magic_item_keyword/edit/:id" element={<MagicItemKeywordEdit/>} />

        <Route path="/dandd/weapon_mastery_property" element={<WeaponMasteryPropertyIndex/>} />
        <Route path="/dandd/weapon_mastery_property/create" element={<WeaponMasteryPropertyEdit/>} />
        <Route path="/dandd/weapon_mastery_property/edit/:id" element={<WeaponMasteryPropertyEdit/>} />
        <Route path="/labs/weapon_mastery_property" element={<WeaponMasteryPropertyIndex/>} />
        <Route path="/labs/weapon_mastery_property/create" element={<WeaponMasteryPropertyEdit/>} />
        <Route path="/labs/weapon_mastery_property/edit/:id" element={<WeaponMasteryPropertyEdit/>} />

        <Route path="/dandd/race" element={<RaceIndex/>} />
        <Route path="/dandd/race/create" element={<RaceEdit/>} />
        <Route path="/dandd/race/edit/:id" element={<RaceEdit/>} />
        <Route path="/labs/race" element={<RaceIndex/>} />
        <Route path="/labs/race/create" element={<RaceEdit/>} />
        <Route path="/labs/race/edit/:id" element={<RaceEdit/>} />

        <Route path="/dandd/subrace" element={<SubraceIndex/>} />
        <Route path="/dandd/subrace/create" element={<SubraceEdit/>} />
        <Route path="/dandd/subrace/edit/:id" element={<SubraceEdit/>} />
        <Route path="/labs/subrace" element={<SubraceIndex/>} />
        <Route path="/labs/subrace/create" element={<SubraceEdit/>} />
        <Route path="/labs/subrace/edit/:id" element={<SubraceEdit/>} />

        <Route path="/dandd/spell_list" element={<SpellListIndex/>} />
        <Route path="/dandd/spell_list/create" element={<SpellListEdit/>} />
        <Route path="/dandd/spell_list/edit/:id" element={<SpellListEdit/>} />
        <Route path="/labs/spell_list" element={<SpellListIndex/>} />
        <Route path="/labs/spell_list/create" element={<SpellListEdit/>} />
        <Route path="/labs/spell_list/edit/:id" element={<SpellListEdit/>} />

        <Route path="/dandd/template_base" element={<TemplateBaseIndex/>} />
        <Route path="/dandd/template_base/create" element={<TemplateBaseEdit/>} />
        <Route path="/dandd/template_base/edit/:id" element={<TemplateBaseEdit/>} />
        <Route path="/labs/template_base" element={<TemplateBaseIndex/>} />
        <Route path="/labs/template_base/create" element={<TemplateBaseEdit/>} />
        <Route path="/labs/template_base/edit/:id" element={<TemplateBaseEdit/>} />

        <Route path="/dandd/floating_feature" element={<FloatingFeatureIndex/>} />
        <Route path="/dandd/floating_feature/create" element={<FloatingFeatureEdit/>} />
        <Route path="/dandd/floating_feature/edit/:id" element={<FloatingFeatureEdit/>} />
        <Route path="/labs/floating_feature" element={<FloatingFeatureIndex/>} />
        <Route path="/labs/floating_feature/create" element={<FloatingFeatureEdit/>} />
        <Route path="/labs/floating_feature/edit/:id" element={<FloatingFeatureEdit/>} />

        <Route path="/dandd/special_feature" element={<SpecialFeatureIndex/>} />
        <Route path="/dandd/special_feature/create" element={<SpecialFeatureEdit/>} />
        <Route path="/dandd/special_feature/edit/:id" element={<SpecialFeatureEdit/>} />
        <Route path="/labs/special_feature" element={<SpecialFeatureIndex/>} />
        <Route path="/labs/special_feature/create" element={<SpecialFeatureEdit/>} />
        <Route path="/labs/special_feature/edit/:id" element={<SpecialFeatureEdit/>} />

        <Route path="/dandd/tool" element={<ToolIndex/>} />
        <Route path="/dandd/tool/create" element={<ToolEdit/>} />
        <Route path="/dandd/tool/edit/:id" element={<ToolEdit/>} />
        <Route path="/labs/tool" element={<ToolIndex/>} />
        <Route path="/labs/tool/create" element={<ToolEdit/>} />
        <Route path="/labs/tool/edit/:id" element={<ToolEdit/>} />

        {/* <Route path="/dandd/organization" element={<OrganizationIndex/>} />
        <Route path="/dandd/organization/create" element={<OrganizationEdit/>} />
        <Route path="/dandd/organization/edit/:id" element={<OrganizationEdit/>} />
        <Route path="/labs/organization" element={<OrganizationIndex/>} />
        <Route path="/labs/organization/create" element={<OrganizationEdit/>} />
        <Route path="/labs/organization/edit/:id" element={<OrganizationEdit/>} />
        
        <Route path="/dandd/org_position" element={<OrgPositionIndex/>} />
        <Route path="/dandd/org_position/create" element={<OrgPositionEdit/>} />
        <Route path="/dandd/org_position/edit/:id" element={<OrgPositionEdit/>} />
        <Route path="/labs/org_position" element={<OrgPositionIndex/>} />
        <Route path="/labs/org_position/create" element={<OrgPositionEdit/>} />
        <Route path="/labs/org_position/edit/:id" element={<OrgPositionEdit/>} /> */}
{/*         
        <Route path="/dandd/org_instance" element={<OrgInstanceIndex/>} />
        <Route path="/dandd/org_instance/create" element={<OrgInstanceEdit/>} />
        <Route path="/dandd/org_instance/edit/:id" element={<OrgInstanceEdit/>} />
        <Route path="/labs/org_instance" element={<OrgInstanceIndex/>} />
        <Route path="/labs/org_instance/create" element={<OrgInstanceEdit/>} />
        <Route path="/labs/org_instance/edit/:id" element={<OrgInstanceEdit/>} /> */}

        <Route path="/dandd/source_book" element={<SourceBookIndex/>} />
        <Route path="/dandd/source_book/create" element={<SourceBookEdit/>} />
        <Route path="/dandd/source_book/edit/:id" element={<SourceBookEdit/>} />
        <Route path="/labs/source_book" element={<SourceBookIndex/>} />
        <Route path="/labs/source_book/create" element={<SourceBookEdit/>} />
        <Route path="/labs/source_book/edit/:id" element={<SourceBookEdit/>} />

        <Route path="/dandd/standard_features" element={<StandardFeaturesIndex/>} />
        <Route path="/dandd/standard_features/create" element={<StandardFeaturesEdit/>} />
        <Route path="/dandd/standard_features/edit/:id" element={<StandardFeaturesEdit/>} />
        <Route path="/labs/standard_features" element={<StandardFeaturesIndex/>} />
        <Route path="/labs/standard_features/create" element={<StandardFeaturesEdit/>} />
        <Route path="/labs/standard_features/edit/:id" element={<StandardFeaturesEdit/>} />

        {/* <Route path="/labs/fixer" element={<FixerPage/>} />
        <Route path="/labs/admin_only" element={<AdminOnly/>} />
        <Route path="/labs/display_image" element={<DisplayImage/>} /> */}
      </Routes>
    );
  }
}
